<template>
    <ul id="hire_me_list">
        <template v-for="item in contents" :key="item.text">
            <li @click.stop.prevent="handleMenuItemClick(item.text)"
                class="toc_item" :class="{ selected: selected === underscore(item.text) }" ><a :href="'#' + underscore(item.text)">{{item.text}}</a></li>
        </template>
    </ul>
</template>

<script>
    import zenscroll from 'zenscroll'

    export default {
        name: "HireMeMenu",
        components: {

        },
        props: {
            contents: Array
        },
        data () {
            return {
                selected: ''
            } 
        },
        computed: {

        },
        methods: {
            underscore (text) {
                text = text.replace(/\(.*\)/g, '').trim()
                return text.replace(/\s/g, '_')
            },
            handleMenuItemClick (text) {
                const id = this.underscore(text)
                this.$router.replace({ hash: '#' + id })
                let el = document.getElementById(id)

                let diff = Math.abs(el.offsetTop - window.pageYOffset)

                zenscroll.toY(el.offsetTop, Math.min(diff, 2000))
            }
        },
        watch: {
            $route (to, from) {
                if (to.hash) this.selected = to.hash.slice(1)
                else this.selected = this.underscore(this.contents[0].text)
            }
        },
        mounted () {
            setTimeout(() => {
                this.selected = this.underscore(this.contents[0].text)
            }, 150);
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/assets/variables';
    #hire_me_list {
        list-style-type: none;
        padding-left: 0;
    }

    .toc_item {
        cursor: pointer;
        padding: 10px 15px;
        margin-bottom: 7px;
        border-radius: 5px;
        transition: all 250ms linear;

        a {
            text-decoration: none;
            color: inherit;
        }

        &.selected {
            background: $light-blue;
            box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.05);
        }
    }
</style>